export type StreamEntitySlug =
  | 'account'
  | 'workspaces'
  | 'contacts'
  | 'notifications'
  | 'calls'
  | 'tasks'
  | 'notes'
  | 'tags'
  | 'tag-links'
  | 'board-columns'
  | 'board-items'
  | 'price-proposals'
  | 'price-proposals-settings'
  | 'payments'
  | 'files'
  | 'custom-fields'
  | 'custom-field-values'
  | 'proforma-invoices';

export const PERSONAL_SCOPE = 'personal';

export const PERSONAL_ENTITY_ORDER: StreamEntitySlug[] = [
  'account',
  'workspaces',
  'contacts',
  'notifications',
  'calls',
];

export const WORKSPACE_ENTITY_ORDER: StreamEntitySlug[] = [
  'contacts',
  'tasks',
  'notes',
  'tags',
  'tag-links',
  'board-columns',
  'board-items',
  'notifications',
  'price-proposals',
  'price-proposals-settings',
  'payments',
  'files',
  'custom-fields',
  'custom-field-values',
  'proforma-invoices',
];

export const STREAM_ENTITIES: StreamEntitySlug[] = Array.from(
  new Set([...PERSONAL_ENTITY_ORDER, ...WORKSPACE_ENTITY_ORDER])
);

export const ENTITY_RESPONSE_TYPE_MAP: Record<StreamEntitySlug, string> = {
  account: 'account',
  workspaces: 'workspace',
  contacts: 'contact',
  notifications: 'notification',
  calls: 'call',
  tasks: 'task',
  notes: 'note',
  tags: 'tag',
  'tag-links': 'tag_link',
  'board-columns': 'board_column',
  'board-items': 'board_item',
  'price-proposals': 'price_proposal',
  'price-proposals-settings': 'price_proposal_settings',
  payments: 'payment',
  files: 'file',
  'custom-fields': 'custom_field',
  'custom-field-values': 'custom_field_value',
  'proforma-invoices': 'proforma_invoice',
};
